import { Box, Text } from "@chakra-ui/react";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";

const NoTimedEvents = ({ onClickCreateTimedLimitiedBtn }) => {
  const { t } = useTranslation();
  return (
    <Box bg="light" paddingInline={4} paddingBlock={8} textAlign="center">
      <Text textTransform="capitalize" color="text" mb={4} fontSize="1.1rem">
        {t("pages.timedEvents.no_data_hint")}
      </Text>
      <GButton
        onClick={onClickCreateTimedLimitiedBtn}
        size="sm"
        title={t("pages.timedEvents.create_timed_events")}
        bg="primary"
        color="light"
        border="1px solid transparent"
        hover={{ bg: "none", color: "primary", borderColor: "primary" }}
      />
    </Box>
  );
};

export default NoTimedEvents;
